import * as actions from '../actionTypes/CheckoutActionTypes';

export const changeAccordion = (accordionIndex) => ({
    type: actions.CHANGE_ACCORDION,
    accordionIndex,
});

export const validateShipping = (value) => ({
    type: actions.VALIDATE_SHIPPING,
    value,
});

export const getCheckoutSectionsInfo = (payload) => ({
    type: actions.GET_CHECKOUT_SECTIONS_INFO,
    payload,
});

export const setMountOnServer = (value) => ({
    type: actions.IS_MOUNT_ON_SERVER,
    value,
});

export const setCreateAccountMessage = (value) => ({
    type: actions.SET_CREATE_ACCOUNT_MESSAGE,
    value,
});

export const setProfileInfo = (value) => ({
    type: actions.SET_PROFILE_INFO,
    value,
});

export const getProfileInfo = (value) => ({
    type: actions.GET_PROFILE_INFO,
    value,
});

export const initNewCheckoutSections = (payload) => ({
    type: actions.INIT_NEW_CHECKOUT_SECTIONS,
    payload,
});

export const initNewCheckoutSectionsClientSideActions = (pageName, isLoadedFromReview) => ({
    type: actions.INIT_NEW_CHECKOUT_SECTIONS_CLIENT_SIDE_ACTIONS,
    pageName,
    isLoadedFromReview,
});

export const setPromotionalEmailSelection = (value = {}) => ({
    type: actions.GET_PROMOTIONAL_EMAIL_SECTION,
    value,
});
